import { ConditionalRender } from '@/features/layouts/components/ConditionalRender';
import { DescriptionRead } from './Description.read';
import { DescriptionWrite } from './Description.write';

export const Description = () => {
  return (
    <ConditionalRender
      read={<DescriptionRead />}
      write={<DescriptionWrite />}
    />
  );
};
